// extracted by mini-css-extract-plugin
export var container = "calculator-module--container--EEnFR";
export var expenseFromAndDetails = "calculator-module--expenseFromAndDetails--1-krR";
export var fadeIn = "calculator-module--fadeIn--1Jt8s";
export var moveLeft = "calculator-module--moveLeft--wnKHj";
export var moveDown = "calculator-module--moveDown--1W7KD";
export var illuMoveDown = "calculator-module--illuMoveDown--11RwI";